module.exports = __webpack_public_path__ + "media/images/svgs/burger-c023611f12b7656c83c0c1cade1f18f1.svg";